
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UILink from "@/components/common/UILink.vue";

  import RouteParams from "@/entities/RouteParams";
  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      UILink,
    },
  })
  export default class ContractorFullInformationLink extends Vue {
    @Prop({ type: String, required: true }) readonly contractorId!: string;

    get routeParams(): RouteParams<{ id: string }> {
      return {
        name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
        params: { id: this.contractorId },
      };
    }
  }
